import React, { useEffect, useState } from 'react';
import useFetch from 'Utils/CustomHook';
import Testimonials from './Components/Testimonials';
import UnipathForYou from 'Components/CommonComponents/UnipathForYou/UnipathForYou';
import WhatsappIcon from 'Assets/SVG/whatsappicon.svg';
import fixedaddress from 'Assets/Icons/fixed-placeholder.svg';
import fixedCall from 'Assets/Icons/fixed-call-icon.svg';
import Banner from './Components/Banner';
import PopularPackage from 'Components/CommonComponents/PackageList/PopularPackage';
import PopularLabTests from 'Components/CommonComponents/LapTestList/PopularLabTests';
import Organs from 'Components/CommonComponents/Organs/Organs';
import AddAddressModal from './Components/AddAddressModal';
import BaseLayout from 'Components/Layout/BaseLayout';
import WhyUnipath from 'Components/Footer/WhyUnipath';
import GetACallBackModal from './Components/GetACallBackModal';
import { useDispatch, useSelector } from 'react-redux';
import OurDivisions from './Components/Divisions';
import WeekendWellness from './Components/WeekendWellness';
import axiosInstance from 'Utils/Interceptor';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Icon } from '@iconify/react';
import DiscountBanner from './Components/DiscountBanner';
import DiscountBannerModal from 'Components/CommonComponents/DiscountBanner/DiscountBannerModal';
import { setIsDiscountModalOpen } from '../../Redux/features/StateSlice';
import { Link, useNavigate } from 'react-router-dom';
import useScrollTrigger from 'Utils/UseScrollTrigger';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { slugify } from 'Utils/Functions';
import LablistCityWise from './Components/LabList';

const HomeGlobal = () => {
  const [showLabModal, setShowLabModal] = useState(false);
  const [labList, setLabList] = useState([]);
  const { isDiscountModalOpen } = useSelector((state) => state?.state);
  const homeData = useSelector((e) => e?.states.homePageData);
  const [faqs, setFaqs] = useState([]);
  const [error, setError] = useState(null);
  const [metaContent, setMetaContent] = useState('');
  const { isLocation } = useSelector((state) => state.location);
  const dispatch = useDispatch();
  const location = useLocation();

  const removeBanner = () => {
    dispatch(setIsDiscountModalOpen(null));
  };

  const { data: organsList } = useFetch('/api/user/organs?limit=20', {
    method: 'get'
  });

  const { data: featuredPackages } = useFetch(
    `/api/user/featured-packages?limit=-1`,
    {
      method: 'get'
    }
  );

  const handleWhatsappClick = () => {
    window.open(
      `https://wa.me/${
        homeData?.whatsapp_channel_number
      }?text=${encodeURIComponent('Hi')}`,
      '_blank'
    );
  };

  const handleLabModal = () => {
    setShowLabModal(!showLabModal);
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const openModal = () => {
    dispatch(setIsDiscountModalOpen(true));
  };

  useScrollTrigger(openModal, 100, isLocation && isDiscountModalOpen !== null);

  const fetchFaqs = async () => {
    try {
      const { data } = await axiosInstance(
        `/api/user/faqs?page=global&limit=5` // No cityId for global
      );
      if (data) {
        setFaqs(data?.data || []);
      }
    } catch (error) {
      setError('Failed to fetch FAQs');
    } finally {
    }
  };

  // For global, fetch all labs (or none, as per your API design)
  const fetchLabs = async () => {
    try {
      const { data } = await axiosInstance(
        `/api/user/labs?city_name=&branch_name=`
      );
      if (data) {
        setLabList(data?.data || []);
      }
    } catch (error) {
      setError('Failed to fetch Labs');
    } finally {
    }
  };

  useEffect(() => {
    fetchLabs();
  }, []);

  return (
    <BaseLayout
      _class={'home-page'}
      from={'HomeGlobal'}
    >
      <>
        <Helmet>
          <link
            rel="canonical"
            href={`${process.env.REACT_APP_URL}${location.pathname}`}
          />
          <title>
            {metaContent?.meta_title
              ? metaContent.meta_title
              : 'Unipath–Trusted Pathology Lab & Blood Test Laboratory'}
          </title>
          <meta
            name="keywords"
            content={
              metaContent?.meta_keyword
                ? metaContent?.meta_keyword
                : 'diagnostic centre near me, pathology lab, diagnostics center near me, diagnostic center, diagnostics lab near me, pathology centre near me'
            }
          />
          <meta
            name="description"
            content={
              metaContent?.meta_description
                ? metaContent?.meta_description
                : 'Unipath is a leading pathology laboratory offering accurate and reliable blood tests. Book your test online at a trusted pathology lab near you for fast & precise diagnostics.'
            }
          />
          <meta
            name="google-site-verification"
            content="MfXd2vttMiEYZH79mIiuewn65fs8viaclnt7pcqWnAI"
          />
        </Helmet>
        <Banner
          data={homeData?.banners}
          heading={metaContent?.page_heading}
          content={metaContent?.page_content}
        />
        <div
          onClick={handleLabModal}
          className="callback-fixed address"
        >
          <div
            to=""
            className="callback-text"
          >
            <img
              src={fixedaddress}
              alt=""
            />
            Find a Lab
          </div>
        </div>
        <section className="popular-health-section">
          {homeData?.healthpackages.length > 0 && (
            <PopularPackage
              data={homeData?.healthpackages}
              heading={'Popular Health Packages'}
              showViewAll={homeData?.healthpackages?.length === 4}
            />
          )}
        </section>
        <section className="city-selection-section">
          <div className="container">
            <div className="section-heading text-center">
              <h2>We’re Operational In These Cities</h2>
              <p>
                Select your city to explore location-specific tests and
                services.
              </p>
            </div>
            <div className="city-cards-wrapper">
              {[
                { name: 'Ahmedabad', slug: 'ahmedabad' },
                { name: 'Surat', slug: 'surat' },
                { name: 'Anand', slug: 'anand' }
              ].map((city, index) => (
                <div
                  key={index}
                  className="city-card"
                >
                  <div className="city-icon">
                    <img
                      src="/assets/icons/city-placeholder.svg"
                      alt={city.name}
                    />
                  </div>
                  <h3>{city.name}</h3>
                  <Link to={`/${slugify(city.name)}`}>
                    <button className="explore-btn">Explore</button>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="for-you-section">
          <UnipathForYou from="HomeGlobal" />
        </section>
        <section className="popular-lab-test-section pt-0">
          {homeData?.popularlabtests.length > 0 && (
            <PopularLabTests
              data={homeData?.popularlabtests}
              heading={'Popular Blood Tests'}
              showViewAll={homeData?.popularlabtests?.length === 5}
            />
          )}
        </section>
        <section className="popular-lab-test-section pt-0">
          {homeData?.popularlabtests.length > 0 && (
            <LablistCityWise
              data={labList}
              heading={'Our Labs and Collection Centres'}
              cityName={''}
              showViewAll={homeData?.popularlabtests?.length === 5}
            />
          )}
        </section>
        {featuredPackages?.data?.length > 0 && (
          <section className="two-column-setion">
            <WeekendWellness data={featuredPackages?.data} />
          </section>
        )}
        {organsList?.data?.length > 0 && (
          <section className="search-organ-section pt-0">
            <Organs data={organsList?.data} />
          </section>
        )}
        <section className="search-organ-section pt-0">
          <DiscountBanner />
        </section>
        {homeData?.divisions?.length && (
          <section className="our-divison-section pt-0">
            <OurDivisions data={homeData?.divisions} />
          </section>
        )}
        <section className="happy-customer-section pt-0">
          <Testimonials data={homeData?.testimonials} />
        </section>
        {showLabModal && (
          <AddAddressModal
            show={showLabModal}
            handleCloseModal={handleLabModal}
          />
        )}
        {faqs.length > 0 && (
          <section className="faq-section pt-0">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="section-heading mt-4">
                    <h2>Frequently Asked Questions</h2>
                    <Link
                      className={`viewall-btn false`}
                      to={'/frequently-asked-questions'}
                    >
                      View All
                    </Link>
                  </div>
                  {faqs.length > 0 && (
                    <div className="faq-list">
                      {faqs.map((faq, index) => (
                        <Accordion
                          key={index}
                          sx={{
                            marginBottom: '1rem',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            boxShadow: 'none',
                            '&:before': { display: 'none' },
                            '&.MuiAccordion-root.Mui-expanded': {
                              marginBottom: '1rem'
                            }
                          }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <Icon
                                color="black"
                                width={22}
                                icon={'mingcute:down-line'}
                              />
                            }
                            aria-controls={`panel${index}-content`}
                            id={`panel${index}-header`}
                            sx={{
                              backgroundColor: '#f5f5f5',
                              padding: '0.5rem 1rem',
                              '& .MuiAccordionSummary-content': {
                                margin: 0
                              }
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              component="h3"
                              sx={{ fontWeight: 'bold' }}
                            >
                              {faq.question}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{ padding: '1rem', backgroundColor: '#fff' }}
                          >
                            <Typography
                              component="div"
                              dangerouslySetInnerHTML={{ __html: faq.answer }}
                            />
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}
      </>
      {isLocation && isDiscountModalOpen && (
        <DiscountBannerModal setClose={removeBanner} />
      )}
      <section className="why-unipath-section">
        <WhyUnipath />
      </section>
    </BaseLayout>
  );
};

export default HomeGlobal;
